"use client"

import { useState } from "react"
import PricingTableView3 from "@/components/pricingNew3"
import SignupModal from "./SignupModal"
import LoginModal from "./LoginModal"

export default function PricingWithModal({ accueil1_sinon0, tarifData, withReduc }: { accueil1_sinon0: number; tarifData?: any; withReduc?: boolean }) {
    const [isSignupOpen, setIsSignupOpen] = useState(false)
    const [isLoginOpen, setIsLoginOpen] = useState(false)

    return (
        <>
            <PricingTableView3
                accueil1_sinon0={accueil1_sinon0}
                tarifData={tarifData}
                withReduc={withReduc}
                onSignupClick={() => setIsSignupOpen(true)}
            />
            <SignupModal
                isOpen={isSignupOpen}
                onClose={() => setIsSignupOpen(false)}
                onSwitchToLogin={() => { setIsSignupOpen(false); setIsLoginOpen(true) }}
            />
            <LoginModal
                isOpen={isLoginOpen}
                onClose={() => setIsLoginOpen(false)}
                onSwitchToSignup={() => { setIsLoginOpen(false); setIsSignupOpen(true) }}
            />
        </>
    )
}
